import type { FC } from "react";
import { Button } from "primereact/button";
import { TEXT } from "@/constants/text";
import styles from "@/pages/admin/UserManagementPage/UserManagementHeader.module.css";

interface UserManagementHeaderProps {
  onInviteUser: () => void;
}

const UserManagementHeader: FC<UserManagementHeaderProps> = ({
  onInviteUser,
}) => (
  <div className={styles.header}>
    <div className={styles.titleBlock}>
      <h2 className={styles.title}>{TEXT.userManagement.pageTitle}</h2>
      <p className={styles.subtitle}>{TEXT.userManagement.pageSubtitle}</p>
    </div>
    <Button
      icon="pi pi-plus"
      label={TEXT.userManagement.inviteUserButton}
      pt={{ root: { className: styles.inviteButton } }}
      onClick={onInviteUser}
    />
  </div>
);

export default UserManagementHeader;
